"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const core_1 = require("@emotion/core");
const lodash_1 = __importDefault(require("lodash"));
const SampleDataSubheading_1 = __importDefault(require("../../sample/SampleDataSubheading"));
const NoSamplesFoundSubheading_1 = __importDefault(require("../../sample/NoSamplesFoundSubheading"));
const AccountSpecifications_1 = __importDefault(require("../../sample/AccountSpecifications"));
const common_utils_1 = require("@zapier/common-utils");
const hookUrlStyle = core_1.css `
  font-family: monospace;
`;
function Subheading({ actionNounInLowercase, authTitle, hasServiceAuthType, serviceKey, serviceName, webhookUrl, }) {
    if (webhookUrl) {
        return (core_1.jsx(react_1.default.Fragment, null,
            "This request was sent to ",
            core_1.jsx("span", { css: hookUrlStyle }, webhookUrl),
            "."));
    }
    return (core_1.jsx(react_1.default.Fragment, null,
        "This ",
        actionNounInLowercase,
        " was found in your",
        ' ',
        core_1.jsx(AccountSpecifications_1.default, { authTitle: authTitle, hasServiceAuthType: hasServiceAuthType, serviceKey: serviceKey, serviceName: serviceName }),
        "."));
}
const MultiSampleDataSubheading = ({ actionNoun, authTitle, isSkipped, service, webhookUrl, }) => {
    const serviceKey = lodash_1.default.get(service, ['key']);
    const serviceName = lodash_1.default.get(service, ['name']);
    const serviceAuthType = lodash_1.default.get(service, ['authType']);
    const serviceBuiltIn = lodash_1.default.get(service, ['isBuiltIn']) || lodash_1.default.get(service, ['builtIn'], false);
    const actionNounInLowercase = actionNoun.toLowerCase();
    const props = {
        actionNounInLowercase,
        authTitle,
        hasServiceAuthType: !lodash_1.default.isEmpty(serviceAuthType),
        serviceKey,
        serviceName,
        serviceBuiltIn,
        webhookUrl,
    };
    return isSkipped ? (core_1.jsx(NoSamplesFoundSubheading_1.default, Object.assign({}, props))) : (core_1.jsx(SampleDataSubheading_1.default, { emoji: {
            label: 'party popper',
            symbol: '🎉',
        }, heading: `We found ${common_utils_1.prefixWithArticle(actionNounInLowercase)}!`, subtextComponent: core_1.jsx(Subheading, Object.assign({}, props)) }));
};
exports.default = MultiSampleDataSubheading;
